import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ProtocolServiceConfig } from './protocol-service.types';

export function provideProtocolService(config: ProtocolServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'protocolServiceConfig', useValue: config }
  ]);
}
